import { render, staticRenderFns } from "./Nomad.vue?vue&type=template&id=37a98712&scoped=true&"
var script = {}
import style0 from "./Nomad.vue?vue&type=style&index=0&id=37a98712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a98712",
  null
  
)

export default component.exports